import { useSelector } from 'react-redux';

export const Government = (props) => {
  const isAnimation = useSelector((state) => state.info.isAnimation);
  const {
    handleGovernmentRock = Function.prototype,
    handleGovernmentScissors = Function.prototype,
    handleGovernmentPaper = Function.prototype,
  } = props;

  return (
    <div
      className='footer__government government'
      style={isAnimation ? { opacity: '0.3' } : { opacity: '1' }}
    >
      <div className='government__rock' onClick={handleGovernmentRock}></div>
      <div
        className='government__scissors'
        onClick={handleGovernmentScissors}
      ></div>
      <div className='government__paper' onClick={handleGovernmentPaper}></div>
    </div>
  );
};
